class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.hasLoaded = false;
  }
  connectedCallback() {
    this.initializeRecommendations()
  }
  // New method to manually initialize
  initializeRecommendations() {
    if (this.hasLoaded) return;
    
    this.hasLoaded = true;
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        } else {
          // Fallback to use complete response
          this.innerHTML = text;
        }
      })
      .catch(e => {
        this.hasLoaded = false;
        console.error('Error loading recommendations:', e);
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);